// extracted by mini-css-extract-plugin
export default {"container":"style_container__S2La3","text":"style_text__wm9mF","button":"style_button__+vPMc"};